import { useState, useEffect } from "react";

const formatLabel = (key) => {
    return key
        .replace(/([a-z])([A-Z])|([A-Z]+)([A-Z][a-z])/g, "$1$3 $2$4")
        .trim()
        .replace(/^./, (str) => str.toUpperCase());
};

const getColumns = (data, windowWidth) => {
    const allKeys = data.reduce((keys, item) => {
        Object.keys(item).forEach((key) => {
            if (!keys.includes(key)) {
                keys.push(key);
            }
        });
        return keys;
    }, []);

    const newArray = allKeys.map((key) => {
        if (key === "serviceDays") {
            return {
                label: "Daily Services",
                renderCell: (item) =>
                    windowWidth < 768 ? item.serviceDaysResponsive : item.serviceDays,
            };
        }

        return {
            label: formatLabel(key),
            renderCell: (item) => item[key],
        };
    });

    return newArray
        .filter(
            (item) => item.label !== "Service Days Responsive" && item.label !== "Id"
        )
        .map((item) => {
            if (item.label.toLowerCase().includes("dfw")) {
                item.label = item.label.replace("Dfw", "DFW");
            }

            return item;
        });
};

export const UseColumns = (from, to, data) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        setColumns(getColumns(data, windowWidth));
    }, [from, to, windowWidth, data]);

    return columns;
};
